import { createContext } from 'react';
import { TUserCardInfo } from '@xhype/card-app-sdk';

interface SelectedCard {
  id: number;
  name: string;
  value: string;
}

interface CardContextType {
  selectedCard: SelectedCard | null;
  selectedCardInfo: TUserCardInfo | null;
  setSelectedCard: (card: SelectedCard | null) => void;
  cardsData: TUserCardInfo[] | undefined;
  cardOptions: { id: number; name: string; value: string }[];
  isLoading: boolean;
  error: any;
  refetch: () => void;
}

export const CardContext = createContext<CardContextType | undefined>(
  undefined,
);
